module.exports = __webpack_public_path__ + "static/media/notFilesFound.4732084a.svg";